import _ from 'lodash';
import qs from 'qs';
import { programs } from '@/utils/constants';
import { bizmatesBaseApi } from '@/utils/bizmatesApi';

export default {
  namespaced: true,
  state: {
    studentProfile: {},
    selectedTrainerInfo: {},
    selectedProgramId: programs.bizmates,
    selectedSchedule: {},
    ticket: {},
    trainerInfo: null,
    selectedRankId: null,
    selectedOtherProgramLesson: null,
    isBookedSuccessfully: false,
    discoveryCategoryIds: [],
    discoveryCategories: [],
    discoveryArticleId: null
  },
  getters: {
    isOtherProgram: state => {
      return state.selectedProgramId === programs.other;
    },
    isBizmatesProgram: state => {
      return state.selectedProgramId === programs.bizmates;
    },
    isAssistLesson: state => {
      return state.selectedProgramId === programs.assist_lesson;
    },
    isDiscoveryLesson: state => {
      return state.selectedProgramId === programs.discovery;
    },
    trainerName: state => {
      return `${state.selectedTrainerInfo.trainer.nickname}（${state.selectedTrainerInfo.trainer.nickname_kana}）`;
    },
    trainerInfo: state => {
      return _.merge(state.selectedTrainerInfo, state.selectedTrainerInfo.trainer);
    },
    trainerMemo: state => {
      return state.selectedTrainerInfo.memo;
    },
    getBookingData: state => {
      return {
        teacher_id: state.selectedTrainerInfo.trainer.teacher_id,
        lesson_date: state.selectedSchedule.lesson_date,
        discovery_lesson_date: state.selectedSchedule.lesson_date,
        time_table_id: state.selectedSchedule.time_table_id,
        ticket_id: state.ticket.id,
        program_id: state.selectedProgramId || programs.bizmates,
        category: '', // TODO
        rank_id: state.selectedOtherProgramLesson ? state.selectedOtherProgramLesson.rank_id : null,
        discovery_article_id: state.discoveryArticleId || '',
        lesson_platform_id: 2
      };
    },
    discoveryData: state => {
      return {
        discovery_lesson_date: state.selectedSchedule.lesson_date,
        discovery_time_table_id: state.selectedSchedule.time_table_id,
        discovery_ticket_id: state.ticket.id,
        discovery_book_id: '',
        discovery_teacher_id: state.selectedTrainerInfo.trainer.teacher_id,
        org_url: location.href,
        discovery_category_id: state.discoveryCategoryIds.toString()
      };
    }
  },
  mutations: {
    setSelectedTrainerInfo(state, payload) {
      state.selectedTrainerInfo = payload;
    },
    setStudentProfile(state, payload) {
      state.studentProfile = payload;
    },
    setProgramId(state, payload) {
      state.selectedProgramId = payload;
    },
    setSchedule(state, payload) {
      state.selectedSchedule = payload;
    },
    setTrainerInfo(state, payload) {
      state.trainerInfo = payload;
    },
    setSelectedRankId(state, payload) {
      state.selectedRankId = payload;
    },
    setSelectedOtherProgramLesson(state, payload) {
      state.selectedOtherProgramLesson = payload;
    },
    setTicket(state, payload) {
      state.ticket = payload;
    },
    setDiscoveryCategoryIds(state, payload) {
      state.discoveryCategoryIds = payload;
    },
    setDiscoveryCategoryDescription(state, payload) {
      state.discoveryCategories = payload;
    },
    setDiscoveryArticleId(state, payload) {
      state.discoveryArticleId = payload;
    }
  },
  actions: {
    async saveBooking({ state, getters }, payload) {
      const params = _.merge(getters.getBookingData, payload);
      await bizmatesBaseApi.post(
        'student/book.json',
        qs.stringify(params),
        {},
        response => {
          state.isBookedSuccessfully = response.data.result;
        },
        err => {
          state.isBookedSuccessfully = false;
          console.log('[Instant Booking]Something Went wrong: ', err);
        }
      );
    }
  }
};
